'use client';

import styled from 'styled-components';
import { H1, H2, H3 } from 'components/Fonts/Font';

export const IUHeader = styled.div`
  display: flex;
  background: var(--darkGrey);
  padding: 30px 15px;
  flex-direction: column;
  text-align: center;
  align-items: center;
  @media only screen and (min-width: 768px) {
    padding: 100px 40px;
  }
`;

export const IUH1 = styled(H1)`
  color: #fff;
  font-size: 2.4rem;
  @media only screen and (min-width: 768px) {
    font-size: 3.7rem;
  }
`;

export const IUH2 = styled(H2)`
  color: #fff;
  font-size: 1.4rem;
  color: var(--blue);
  max-width: 600px;
  margin-top: 12px;
  @media only screen and (min-width: 768px) {
    font-size: 2rem;
  }
`;

export const AlbumContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-bottom: 4px solid var(--blue);
  box-shadow: rgba(0, 0, 0, 0.1) 4px 4px 9px 3px;
  @media only screen and (min-width: 700px) {
    flex-direction: row;
  }
  img {
    width: 100%;
    height: 100%;
    /* max-width: 400px; */
    @media only screen and (min-width: 700px) {
      max-width: 400px;
    }
    @media only screen and (min-width: 950px) {
      /* max-width: 400px; */
    }
  }
`;

export const Entry = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 80px 0;
`;

export const AlbumList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const AlbumListItem = styled.li`
  padding: 5px 0;
  a {
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }
  p {
    font-style: italic;
    font-size: 1rem;
    margin-bottom: 0;
  }
  &:nth-child(even) {
    background: #fff;
  }
  &:hover {
    background: var(--darkGrey);
    h2,
    h3,
    h4 {
      color: #fff;
    }
  }
`;

export const Star = styled.span`
  color: var(--red);
  margin: 0 2px;
  font-size: 1.6rem;
  @media only screen and (min-width: 950px) {
    font-size: 2rem;
    margin: 0 20px;
  }
`;

export const Feature = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 80px 0;
  text-decoration: none;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

export const FeatureHeader = styled(H3)`
  font-family: ${(props) => props.theme.fonts.serifDisplay};
  font-size: 1.4rem;
  color: var(--darkBlue);
  @media only screen and (min-width: 768px) {
    font-size: 2rem;
  }
`;

export const FeatureH2 = styled(H2)`
  font-size: 1.8rem;
  color: var(--darkGrey);
  @media only screen and (min-width: 768px) {
    font-size: 2.8rem;
  }
  &:before,
  &:after {
    content: '★';
    color: var(--red);
    margin: 10px 10px;
    font-size: 1.6rem;
    @media only screen and (min-width: 950px) {
      font-size: 2rem;
      margin: 10px 15px;
    }
  }
`;

export const Tracks = styled.ol`
  display: flex;
  width: 100%;
  flex-direction: column;
  background: #fff;
  justify-content: center;
  padding: 0px 15px;

  li {
    font-size: 0.9rem;
    line-height: 1.6rem;
    margin: 0;
  }
  @media only screen and (min-width: 768px) {
    margin-top: 0px;
    li {
      line-height: 1.75rem;
      font-size: 1.1rem;
    }
  }
`;

export const Album = styled.div`
  width: 100%;
  margin: 0 auto;
  @media only screen and (min-width: 500px) {
    width: 85%;
  }
  @media only screen and (min-width: 700px) {
    width: 100%;
  }
  article {
    margin: 0px auto;

    p {
      font-size: 1rem;
      line-height: 1.7rem;
      @media only screen and (min-width: 768px) {
        font-size: 1.1rem;
        line-height: 1.7rem;
      }
    }
  }

  blockquote {
    font-size: 2.1rem;
    font-style: italic;
    line-height: 2.6rem;
    background: var(--darkGrey);
    color: #fff;
    font-weight: 400;
    padding: 15px;
    margin: 1.5rem 0rem;
    font-family: ${(props) => props.theme.fonts.serif};
    font-weight: 700;
    @media only screen and (min-width: 768px) {
      margin: 1.5rem 0rem;
    }
  }
  figure {
    margin: 0;
    img {
      width: 100%;
      height: auto;
      border: 1px solid #f3f3f3;
    }
    @media only screen and (min-width: 768px) {
      width: 60%;
      float: right;
      padding: 0 0 0 20px;
    }
  }
`;

export const Social = styled.div`
  display: flex;
  width: 65px;
  justify-content: space-between;
  align-items: center;
  a {
    text-align: center;
    display: flex;
  }
`;

export const ArticleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  @media only screen and (min-width: 768px) {
    margin: 50px 0;
  }
`;

export const PublishInfo = styled.div`
  display: flex;
  background-color: #fff;
  border-bottom: 4px solid var(--blue);
  box-shadow: rgba(0, 0, 0, 0.1) 4px 4px 9px 3px;
  justify-content: space-between;
  padding: 10px;
`;

export const AuthorContainer = styled.div``;

export const Author = styled.h5`
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
`;

export const AlbumHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 10px;
  border-bottom: 4px solid var(--blue);
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  p {
    font-weight: 600;
    color: var(--darkGrey);
    margin: 0;
  }
`;

export const DatePublished = styled.time`
  font-weight: 500;
  color: var(--darkGrey);
  font-size: 1rem;
  line-height: 1.3rem;
  font-family: ${(props) => props.theme.fonts.sansSerif};
`;
